import clsx from "clsx"
import type { ReactNode } from "react"

import styles from "./SelectCard.module.css"

export interface SelectCardProps {
  selected: boolean
  onSelect: () => void
  children: ReactNode
}

// TODO: Look at merging this into ActionListItem as they are similar
export function SelectCard(props: SelectCardProps) {
  const { selected, onSelect, children } = props

  return (
    <button
      className={clsx(
        styles.cardBase,
        styles[`card-${selected ? "selected" : "default"}`]
      )}
      role="menuitemradio"
      aria-checked={selected}
      onClick={onSelect}
    >
      {children}
    </button>
  )
}
